// @core/api/endpoints/notifications/update_team_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTeamSettingsRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Update team notification settings
 * Updates the notification settings for a team. Changes affect all team members unless they have individual overrides configured.
 */
export async function UpdateTeamSettings(
  team_id: string,
  data: UpdateTeamSettingsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/teams/:team_id/settings`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
